import { Lightning } from '@lightningjs/sdk'

import { transparent } from '../../constants/colors'
import { createKey } from './keyboardUtils'
export default class KeyRow extends Lightning.Component {
  private _rowIndex = 0
  private _keyIndex = 0

  static _template() {
    return {
      rect: true,
      color: transparent,
      collision: true,
      w: (w) => w,
      h: 75,
    }
  }

  set index(v: number) {
    this._rowIndex = v
  }

  set keys(v) {
    this.patch({ children: v.map((k, i) => createKey(k, i, this._rowIndex)) })
  }

  get keyIndex() {
    return this._keyIndex
  }

  set keyIndex(v: number) {
    this._keyIndex = v
  }

  get currentKey() {
    return this.childList.getAt(this.keyIndex)
  }

  get totalKeys() {
    return this.childList.length
  }

  get keyValue() {
    return this.currentKey.value
  }

  _getFocused() {
    return this.currentKey
  }

  _handleRight() {
    if (this.keyIndex === this.totalKeys - 1) {
      return false
    } else {
      this._keyIndex++
    }
  }

  _handleLeft() {
    if (this.keyIndex === 0) {
      return false
    } else {
      this._keyIndex--
    }
  }
}
